import { IToolWidget } from "./toolWidget";

export interface IToolGroupWidget{
    id: string;
    name: string;
    icon: string;
    tools: IToolWidget[];

    html(activeTool: IToolWidget | null): string;
}

export class ToolGroupWidget implements IToolGroupWidget {
    id: string;
    name: string;
    icon: string;
    tools: IToolWidget[];

    constructor(id: string, name: string, icon: string, tools: IToolWidget[]){
        this.id = id;
        this.name = name;
        this.icon = icon;
        this.tools = tools;
    }

    html(activeTool: IToolWidget | null): string{
        let html = '';
        this.tools.forEach((tool: IToolWidget) => {
            html += tool.html(activeTool);
        });
        return html;
    };
}